import React,{useState,useEffect,}from 'react'
import Main from '../../cpn/Main'
import { Table,Space,Modal,message,Flex,} from 'antd';
import { useGwGoodsTypeDelMutation, useGwGoodsTypeListQuery, } from '../../store/ReactWebSiteApi';
import WebGoodsTypeCheck from './WebGoodsTypeCheck';
import WebGoodsTypeEdit from './WebGoodsTypeEdit';
import WebGoodsTypeAdd from './WebGoodsTypeAdd';
import SonTypeList from './SonTypeList';
function WebGoodsType() {
    const {confirm} = Modal; 
    const [submitDel] = useGwGoodsTypeDelMutation()
    const {data,isSuccess} = useGwGoodsTypeListQuery({eowgt_e_id:localStorage.getItem('e_id')})
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                //console.log(data);
                
                const newArr = data.Result.map(item => {
                    const {eowgt_id:key,eowgt_name,eowgt_content,eowgt_uname,eowgt_ctime,eowgt_update_ctime,eowgt_update_uname,sub_num,eowgt_serial_number} = item;
                    return item = {key,eowgt_name,eowgt_content,eowgt_uname,eowgt_ctime,eowgt_update_ctime,eowgt_update_uname,sub_num,eowgt_serial_number}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.eowgt_serial_number;
                    let bTimeString = b.eowgt_serial_number;
                    return aTimeString - bTimeString;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    const columns = [
        {
            key: 'eowgt_serial_number',
            title: '序号',
            dataIndex: 'eowgt_serial_number'
        },
        {
            key: 'tag',
            title: '系统类型',
            dataIndex: 'eowgt_name',
            render:(_,record) => {
                return <WebGoodsTypeCheck
                            text={record.eowgt_name}
                            eowgt_id={record.key}
                        />
            }
        },                 
        {
            key: 'sub_num',
            title: '企业类型数量',
            dataIndex: 'sub_num',
        }, 
        {
            key: 'id',
            title: '编号',
            dataIndex: 'key'
        },       
              
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <Space>
                    <div>新建时间：{record.eowgt_ctime + record.eowgt_uname}</div>
                    <div>修改时间：</div>
                </Space>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>                        
                        <WebGoodsTypeEdit
                            eowgt_id={record.key}
                        />
                        {record.sub_num==='0' && <a onClick={() => {
                            confirm({
                                title: '确定删除吗?',
                                content: '删除后不能恢复',
                                okText: '确认',
                                okType: 'danger',
                                cancelText: '取消',
                                onOk() {
                                    submitDel({eowgt_id:record.key}).then((res) => {
                                        if (res.data.Status === 'success') {
                                            message.info('删除成功！');
                                        }
                                        if (res.data.Status === "fail") {
                                            message.error('删除失败！'+res.data.Message)
                                        }
                                    })
                                },
                                onCancel() {
                                console.log('Cancel');
                                },
                            });
                        }}>删除</a>}
                        <SonTypeList eowgt_id={record.key} />
                    </Space>
                </>
            }
        },
    ]
    
    return (
        <Main selectedKeys={['/WebGoodsTypeList']} >
            <Flex justify='end'>
                <WebGoodsTypeAdd />
            </Flex>
            <Table 
                columns={columns} 
                dataSource={list}
                pagination={{
                    defaultPageSize:50,
                    showSizeChanger:true,
                    showTotal:(total) => `共${total}条`,
                    onChange:(e,f) => {
                        localStorage.setItem('ebn_query_page',e);
                        localStorage.setItem('ebn_query_page_size',f);
                    },
                    showTitle:true,
                }}
            />
        </Main>
    )
}

export default WebGoodsType